import { render, staticRenderFns } from "./FairPayPromoPage.vue?vue&type=template&id=57f6742a&scoped=true"
import script from "./FairPayPromoPage.vue?vue&type=script&setup=true&lang=js"
export * from "./FairPayPromoPage.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FairPayPromoPage.vue?vue&type=style&index=0&id=57f6742a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f6742a",
  null
  
)

export default component.exports